module.exports = __webpack_public_path__ + "img/fasciite-plantaire.39b146c9.jpg";